import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import FileListPageUI from './FileListPageUI.js'

class FileListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null,
      accountFileList: null,
      // metadata
      fileSubmitted: false,
      //
      fileErrorList: null,
    }
  }

  render() {
    return (
      <FileListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
        accountFileList={this.state.accountFileList}
        fileErrorList={this.state.fileErrorList}
        // metadata
        fileSubmitted={this.state.fileSubmitted}
        onFileClick={this.onFileClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getAccountFiles(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getAccountFiles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/files`,
      cacheKey: CacheKeys.AccountFiles(this.props.match.params.accountId),
      callback: this.getAccountFilesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountFilesCallback = (response) => {
    this.setState({ accountFileList: response.accountFileList })
  }

  onFileClick = (event) => {
    let folder = event.currentTarget.getAttribute('data-folder')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ fileSubmitted: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/files/${fileName}/folders/${folder}/metadata`,
      this.onFileClickCallback, null, null
    )
  }

  onFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      fileSubmitted: false
    })

    if (response.errorList.length === 0) {
      let filtered = this.state.accountFileList.filter(
        file => file.folder === response.accountFile.folder && file.fileName === response.accountFile.fileName)
      if (filtered.length > 0) {
        console.log('------');
        filtered[0].updatedByName = response.accountFile.updatedByName
        this.setState({accountFileList: this.state.accountFileList})
      }
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.AccountFiles(this.props.match.params.accountId))
    if (noBusy === 'noBusy')
      this.getAccountFiles(context)
    else
      this.setState({
        errorList: null,
        account: null,
        accountFileList: null
      }, this.getAccounts(context),
        this.getAccountFiles(context)
      )
  }

}

export default withRouter(FileListPageSF)
